import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './base/login/login.component';
import { AuthGuard } from "./base/auth-guard.guard";


const routes: Routes = [
  { path: '', loadChildren: () => import('./base/body/body.module').then(m => m.BodyModule), canActivate: [AuthGuard] },
  { path: 'login', component: LoginComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
